const GameWalkthrough = () => {
  return (
    <div className="game-walkthrough">
      <iframe
        src="/gamemonetize-video.html"
        title="Game walkthrough"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        style={{
          width: "100%",
          height: "480px",
          border: "none",
          display: "block",
        }}
      />
    </div>
  );
};

export default GameWalkthrough;
